export default __webpack_public_path__ + "static/noData-ef12046ebd9fdd1549b4bd3e4f2088e7.png";